// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1JXvv","title":"Home_title__2p6As","subTitle":"Home_subTitle__1cBdr","row":"Home_row___CqSC","search":"Home_search__3j1Qe","workspaces":"Home_workspaces__2YZSx"};